import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatINR, formatApiErrorDetail, formatCompactNumber } from "@/lib/api";

const STATUSES = ["Available", "Limited", "Booked"];

export default function MallOwnerInventory() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  async function load() {
    setLoading(true);
    try { const { data } = await api.get("/mall-owner/inventory"); setRows(data); }
    catch { setRows([]); }
    finally { setLoading(false); }
  }
  useEffect(() => { load(); }, []);

  async function update(id, body) {
    try {
      await api.patch(`/mall-owner/inventory/${id}`, body);
      toast.success("Saved");
      load();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  }

  const filtered = q ? rows.filter((r) =>
    [r.format, r.mall_name, r.city, r.format_category].some((s) => (s || "").toLowerCase().includes(q.toLowerCase()))
  ) : rows;

  return (
    <div data-testid="mall-owner-inventory">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
        <div>
          <div className="text-[11px] uppercase tracking-[0.3em] font-semibold text-[var(--gold)]">Inventory</div>
          <h1 className="mt-3 font-serif-display text-4xl text-[var(--ink)]">{rows.length} ad spaces</h1>
          <p className="mt-2 text-[var(--slate-1)]">Update availability or pricing inline.</p>
        </div>
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search…" className="max-w-xs" data-testid="mo-inv-search" />
      </div>

      <div className="mt-8 surface overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="border-b border-[var(--border)] text-left text-[10px] uppercase tracking-[0.22em] text-[var(--slate-2)]">
            <tr>
              <th className="p-4">Placement</th>
              <th className="p-4">Mall · City</th>
              <th className="p-4">Footfall</th>
              <th className="p-4">Price / day</th>
              <th className="p-4">Status</th>
            </tr>
          </thead>
          <tbody>
            {loading ? <tr><td colSpan="5" className="p-10 text-center text-[var(--slate-2)]">Loading…</td></tr>
            : filtered.length === 0 ? <tr><td colSpan="5" className="p-10 text-center text-[var(--slate-2)]">No matches.</td></tr>
            : filtered.map((i) => (
              <tr key={i.id} className="border-b border-[var(--border)]" data-testid={`mo-inv-${i.id}`}>
                <td className="p-4">
                  <div className="font-medium text-[var(--ink)]">{i.format}</div>
                  <div className="text-xs text-[var(--slate-2)]">{i.placement}</div>
                </td>
                <td className="p-4 text-[var(--slate-1)]">{i.mall_name} · {i.city}</td>
                <td className="p-4 text-[var(--slate-1)] text-xs font-mono">{formatCompactNumber(i.daily_footfall || i.monthly_footfall)}</td>
                <td className="p-4">
                  <input type="number" defaultValue={i.price_per_day || 0} onBlur={(e) => {
                    const v = Number(e.target.value);
                    if (v && v !== i.price_per_day) update(i.id, { price_per_day: v, price_per_week: Math.round(v * 7) });
                  }} className="max-w-[120px] !py-1.5 !px-2 text-xs" />
                  <div className="text-[10px] text-[var(--slate-2)] mt-1">{formatINR(i.price_per_day)}</div>
                </td>
                <td className="p-4">
                  <select value={i.availability} onChange={(e) => update(i.id, { availability: e.target.value })} className="max-w-[140px] !py-1.5">
                    {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
